module.exports = __webpack_public_path__ + "media/images/common/ico-mypage-65f78ed57b6942e57b88f1d17fe9a9ff.svg";